module.exports = __webpack_public_path__ + "media/images/indigo/indigo-hero_stride-00a8c4a869cdfe276c77fd9563d3eced.svg";